import React from 'react';

const COLORS = { down: '#e11d48', up: '#047857', flat: '#64748b' };

/** Tiny inline SVG line of weekly margin % points; null points are skipped. */
export function MarginSparkline({ points = [], trend, width = 44, height = 14, testId }) {
  const known = points.map((p, i) => (p == null ? null : [i, p])).filter(Boolean);
  if (known.length < 2) return <span className="text-slate-300 text-[9px]" data-testid={testId}>no trend</span>;
  const ys = known.map(([, y]) => y);
  const min = Math.min(...ys), max = Math.max(...ys);
  const span = max - min || 1;
  const x = (i) => (i / (points.length - 1)) * (width - 2) + 1;
  const y = (v) => height - 1 - ((v - min) / span) * (height - 2);
  const d = known.map(([i, v], k) => `${k === 0 ? 'M' : 'L'}${x(i).toFixed(1)} ${y(v).toFixed(1)}`).join(' ');
  const [li, lv] = known[known.length - 1];
  const color = COLORS[trend] || COLORS.flat;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="inline-block align-middle" data-testid={testId} aria-hidden="true">
      <path d={d} fill="none" stroke={color} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={x(li)} cy={y(lv)} r="1.6" fill={color} />
    </svg>
  );
}
